// src/components/auth/ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import { PageOverlayLoading } from "../Loading/Spinner.jsx";

/**
 * Reittivartija:
 * - Näyttää overlay-spinnerin, kun sessiota tarkistetaan
 * - Ohjaa /kirjaudu?next=... jos käyttäjä ei ole kirjautunut
 * - Ei enää automaattista /setup-ohjausta
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const auth = useAuth?.() || {};

  // "checking" tilan normalisointi eri nimille
  const checking = auth.checking ?? auth.checkingSession ?? auth.loading ?? false;

  // Authed? – hyväksy joko isAuthenticated-booleanin tai user-olion
  const isAuthed = useMemo(() => {
    if (typeof auth.isAuthenticated === "boolean") return auth.isAuthenticated;
    return !!auth.user;
  }, [auth.isAuthenticated, auth.user]);

  // Näytä selkeä overlay latauksen ajan
  if (checking) return <PageOverlayLoading label="Avataan hallintaa…" />;

  // Ei kirjautunut → ohjaa login-sivulle next-parametrilla
  if (!isAuthed) {
    const next = `${location.pathname}${location.search || ""}${location.hash || ""}`;
    return <Navigate to={`/kirjaudu?next=${encodeURIComponent(next)}`} replace />;
  }

  // Ei enää setup-redirectiä – setupiin mennään vain erikseen
  return children;
}
